import { render, staticRenderFns } from "./addBoxofficeRecordDetail.vue?vue&type=template&id=7a5d9471&scoped=true&"
import script from "./addBoxofficeRecordDetail.vue?vue&type=script&lang=js&"
export * from "./addBoxofficeRecordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5d9471",
  null
  
)

export default component.exports